import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { createContext, useContext, type ReactNode } from 'react';
import { SessionProvider } from '../features/auth/session';
import type { Api } from '../lib/api';

const ApiContext = createContext<Api | null>(null);

export function useApi(): Api {
  const api = useContext(ApiContext);
  if (!api) throw new Error('useApi() outside <Providers>');
  return api;
}

export function Providers({ api, queryClient, children }: { api: Api; queryClient: QueryClient; children: ReactNode }) {
  return (
    <ApiContext.Provider value={api}>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>{children}</SessionProvider>
      </QueryClientProvider>
    </ApiContext.Provider>
  );
}
